
import React from "react";
import css from './SectionHero.module.css';

const SectionHero = props => {
    const { header, content, imageUrl } = props;

    return (
        <div className={css.root}>
            <img
                src={imageUrl}
                alt=""
                className={css.backgroundImage}
            />
            <div className={css.overlay}></div>

            <div className={css.container}>
                {header}
                {content}

            </div>
        </div>
    );
};

export default SectionHero;
